// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"852dca6a","108":"3c4d7d22","231":"e2ef0ee3","535":"92cc8f11","572":"887e5b17","975":"1d039e9b","977":"fb7eae95"}[chunkId] + ".chunk.js";
};